import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import QRCode from './QRCode';
import styles from './SongCard.module.css';

const SongCard = ({
  song,
  revealed,
  yearRevealed = false,
  draggable = true,
  overlay = false,
  onReveal,
  onRevealYear,
}) => {
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: `song-${song.id}`,
    disabled: !draggable,
    data: { song: song },
  });

  const style = transform
    ? {
      transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
    }
    : undefined;

  const getAlbumArtwork = () => {
    if (!song.album_images || song.album_images.length === 0) return null;
    const mediumImage = song.album_images.find((img) => img.width >= 250 && img.width <= 400);
    return mediumImage ? mediumImage.url : song.album_images[0].url;
  };

  const albumArtwork = getAlbumArtwork();

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...(draggable ? listeners : {})}
      className={`${styles.song_card} ${isDragging ? styles.dragging : ''} ${overlay ? styles.overlay : ''}`}>
      {/* Top section: QR code or Album Art */}
      <div className={styles.song_card_top_section}>
        {!revealed ? (
          <QRCode song={song} onReveal={onReveal} />
        ) : (
          <div className={styles.album_art_display}>
            {albumArtwork ? (
              <img
                src={albumArtwork}
                alt={`${song.album} by ${song.artist}`}
                className={styles.revealed_album_image}
              />
            ) : (
              <div className={styles.qr_placeholder}>🎵 No Album Art</div>
            )}
          </div>
        )}
      </div>

      {/* Bottom section: Song Info (always visible when revealed) */}
      <div className={`${styles.card_info} ${!revealed ? styles.hidden : ''}`}>
        <div className={styles.song_title}>{song.title}</div>
        <div className={styles.song_artist}>{song.artist}</div>
        <div className={styles.song_album}>{song.album}</div>
        <div className={`${styles.song_year} ${!yearRevealed ? styles.hidden : ''}`}>{song.release_year}</div>
      </div>
    </div>
  );
};

export default SongCard;